import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'flatManual';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const SET_CLOUD_TYPE = `${NAMESPACE}/SET_CLOUD_TYPE`;

export const CHANGE_PAGE = `${NAMESPACE}/CHANGE_PAGE`;
export const CHANGE_PER_PAGE = `${NAMESPACE}/CHANGE_PER_PAGE`;
export const RESET_PAGE = `${NAMESPACE}/RESET_PAGE`;

export const ARCHIVED_RDC_JOBS_GET = createApiConstants(NAMESPACE, 'ARCHIVED_RDC_JOBS_GET');
export const ARCHIVED_VDC_JOBS_GET = createApiConstants(NAMESPACE, 'ARCHIVED_VDC_JOBS_GET');
